var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pendo-date-picker',{staticClass:"single-date",attrs:{"full-width":"","is-required":"","value":_vm.date,"min-date":_vm.appFirstVisit,"max-date":_vm.yesterday},on:{"select-date":_vm.updateDate}})}
var staticRenderFns = []

export { render, staticRenderFns }